module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-e11c9b20.png";